import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import CompanySubscriptionModal from "../../components/CompanySubscriptionModal";
import Select from 'react-select';
import { thisBaseURL } from "../../utils/helper.js";

let availableCountries = [];
let subscriberCountries = [];
let accessibleCountries = [];
let countryOptions = [];
let defaultCountryName = "";

const smCountryStyles = {
	control: styles => ({
		...styles, backgroundColor: 'white', borderRadius: '10px',
		lineHeight: '25px', minHeight: '30px', height: '35px', fontSize: '16px', verticalAlign: 'middle'
	}),
	option: (styles, state) => {
		return {
			...styles,
			lineHeight: '25px', height: '35px', fontSize: '16px',
			fontWeight: state.isSelected ? "bold" : "normal",
		};
	},
	singleValue: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '16px', marginTop: '4px',
	}),
	indicatorSeparator: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '0px',
	}),
	indicatorContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '4px',
	}),
	indicatorsContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '4px',
	}),
	container: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '16px', whiteSpace: 'nowrap',
	}),
	input: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px',
	}),
	placeholder: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '0px',
	}),
}
const defaultTop = 110;
function LeftMenu({ canRead, countryAnswers, countryList, defaultCountry }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [showSubMsg, setShowSubMsg] = useState(false);
	const [countryLoaded, setCountryLoaded] = useState(false);
    const [scrollTop, setScrollTop]=useState(0);
    
	useEffect(() => {
		setCountryValues(countryList);
		window.addEventListener('scroll',handleCountryScroll);
       return () => {
          window.removeEventListener('scroll',handleCountryScroll);
       };
	}, []);

	function setCountryValues(countries) {
		let countryOptionValue = {};
		let label = '';
		countryOptions = [];
		defaultCountryName = "";
		if (countries && countries.length > 0) {
			countries.map((country, index) => {
				if (country.published && (country.statusCode === 1)) {
					label = country.countryName;
					availableCountries.push(country.name);
					if (country.requireSubscription && !canRead) {
						label = country.countryName + ' $';
						subscriberCountries.push(country.name);
					}
					if (canRead) {
						accessibleCountries.push(country.name);
					}
					if(country.name.toLowerCase() === defaultCountry){
						defaultCountryName = country.countryName;
					}
					countryOptionValue.label = label;
					countryOptionValue.value = country.name;
					countryOptions.push(countryOptionValue);
					countryOptionValue = {};
				}
			});
		}
		setCountryLoaded(true);
	}

	function subscribePopupMsg(display) {
		if (display) {
			document.getElementById("page").classList.add("no-pointer");
			setShowSubMsg(true);
		} else {
			document.getElementById("page").classList.remove("no-pointer");
			setShowSubMsg(false);
		}
	}

	const handleCountryChange = (selectedOption) => {
		let code = selectedOption.value;
		let countryName = selectedOption.label;
		if (subscriberCountries.includes(code) && !accessibleCountries.includes(code)) {
			subscribePopupMsg(true);
		} else {
			navigate('/countries/' + code.toLowerCase(), { replace: true });
			navigate(0);
		}
	};
	
	const handleCountryScroll=() => {
      const offset=window.scrollY;
      //console.log("offset :"+offset);
      
      if(offset > 110 ){
		setScrollTop(offset - defaultTop) ;
      } else{
		setScrollTop(0) ;
      }
    }
	return (<aside id="sidebars" style={{top : scrollTop+'px'}}>
		<section id="sidebar">
			<div className="page-inner">
				{ countryLoaded && (<Select
					name="country"
					onChange={handleCountryChange}
					options={countryOptions}
                     defaultValue={{label :defaultCountryName, value :defaultCountry}}
					isSearchable={true}
					className="myselect"
					styles={smCountryStyles}
				/>
				)}
			</div>
			<div className="flag-container">
				<div className="flag-wrapper">
					<div className={"img-thumbnail flag fi fi-"+defaultCountry}></div>
				</div>
			</div>
			<div className="tabs" role="navigation">
				<ul className="menu">
						<li>
							<a href={thisBaseURL +"/countries/" + defaultCountry +"#population_economy_and_governance"}>Population, Economy, and Governance</a>
						</li>
						<li>
							<a href={thisBaseURL +"/countries/" + defaultCountry +"#climate_and_land_use"}>Climate and Land Use</a>
						</li>
						<li>
							<a href={thisBaseURL +"/countries/" + defaultCountry +"#food_security"}>Food Security</a>
						</li>
						<li>
							<a href={thisBaseURL +"/countries/" + defaultCountry +"#food_production"}>Food Production</a>
						</li>
						<li>
							<a href={thisBaseURL +"/countries/" + defaultCountry +"#trade"}>Trade</a>
						</li>
						<li>
							<a href={thisBaseURL +"/countries/" + defaultCountry +"#food_safety_defense"}>Food Safety &amp; Defense</a>
						</li>
					<li className="switch_profile_item">
						<hr />
						<a href={thisBaseURL + "/foods"}>Switch to foods</a>
					</li>
				</ul>
			</div>
		</section>
		{showSubMsg && <CompanySubscriptionModal setShow={subscribePopupMsg} />}
	</aside>);
}
export default LeftMenu;